document.addEventListener('DOMContentLoaded', function () {
  var button = document.querySelector('[data-back-to-top]');
  if (!button) return;

  function toggleVisibility() {
    if (window.scrollY > 400) {
      button.classList.add('is-visible');
    } else {
      button.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', toggleVisibility, { passive: true });
  toggleVisibility();

  button.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});